import { JwtCustonService } from './../core/auth/jwtCustomService';
import { AppConfig } from 'src/app/core/_config/app.config';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ResponseCustom } from 'src/app/models/ResponseCustom';
import { Observable } from 'rxjs';
import { AuthServiceCustom } from '../core/auth/authServiceCustom';
import { Router } from '@angular/router';
import { SessionBusiness } from '../core/_config/sessionBusiness.service';

@Injectable({
    providedIn: 'root',
})
export class CallbackService {
    private API_URL = this.config.urlApi + this.config.versionApi;

    constructor(
        private http: HttpClient,
        private config: AppConfig,
        private authServiceCustom: AuthServiceCustom,
        private session: SessionBusiness,
        private router: Router,
    ) {}

    private paramBySession() {
        return {
            EntityId: this.session.EntityIdContext,
            CountryId: this.session.CountryIdContext,
            EntityDescription: this.session.EntityDescriptionContext,
            LegalEntityId: this.session.LegalEntityIdContext,
            SystemId: this.session.SdaSystemIdContext,
            SystemName: this.session.SdaSystemNameContext,
        };
    }

    private createHttpOption() {
        return {
            headers: new HttpHeaders({
                CountryId: this.session.CountryIdContext.toString(),
                Authorization: `Bearer ${this.authServiceCustom.accessToken}`,
            }),
        };
    }

    accountsLogin() {
        return new Promise<ResponseCustom>((resolve, reject) => {
            let params = this.paramBySession();

            const httpOptions = this.createHttpOption();

            this.http.post<ResponseCustom>(`${this.API_URL}Login`, params, httpOptions).subscribe((res) => {
                let token = res.data.token;
                sessionStorage.setItem('TokenJwt', token);
                // this.router.navigate(['/home']);
                this.router.navigate([`${sessionStorage.getItem('urlStart')}`]);

                // location.reload();
                resolve(res);
            });
        });
    }
}
